import { z } from 'zod';
import {
  normalizeOptionalBuildTemplateId,
  normalizeOptionalIdentityTemplateId,
} from '@/IsekaiRPG/modules/character/characterSemantic';

import { RankSchema } from '@/IsekaiRPG/shared/types';
import { CharacterProfileSchema } from './characterProfile';

// ============================================
// 角色蓝图
// ============================================

/**
 * 角色蓝图中的机械补充信息。
 *
 * 说明：
 * - profile 是人物设定真相；
 * - mechanics 只保留 profile 中没有、但实例化时仍需要的机械信息。
 */
const CharacterBlueprintMechanicsSchemaBase = z.object({
  identityTemplateId: z
    .preprocess(
      value => normalizeOptionalIdentityTemplateId(typeof value === 'string' ? value : undefined),
      z.string().optional(),
    )
    .optional(),
  buildTemplateId: z
    .preprocess(
      value => normalizeOptionalBuildTemplateId(typeof value === 'string' ? value : undefined),
      z.string().optional(),
    )
    .optional(),
  rank: RankSchema.optional(),
  rngSeed: z.string().optional(),
  seedId: z.string().optional(),
});
export const CharacterBlueprintMechanicsSchema = CharacterBlueprintMechanicsSchemaBase;
export type CharacterBlueprintMechanics = z.infer<typeof CharacterBlueprintMechanicsSchemaBase>;

/**
 * 角色蓝图：
 * - profile：完整人物设定
 * - mechanics：实例化时需要的机械信息
 */
export const CharacterBlueprintSchema = z.object({
  profile: CharacterProfileSchema,
  mechanics: CharacterBlueprintMechanicsSchema.default(() => CharacterBlueprintMechanicsSchema.parse({})),
});
export type CharacterBlueprint = z.infer<typeof CharacterBlueprintSchema>;
